import React from 'react';
import './LoadingOverlay.css';

const LoadingOverlay = ({ isLoading, message = "Loading..." }) => {
  if (!isLoading) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="loading-spinner">
          <img 
            src="/images/loading.gif" 
            alt="Loading..." 
            className="loading-gif"
            onError={(e) => {
              // Fallback if loading.gif doesn't exist
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <div className="loading-fallback" style={{ display: 'none' }}>
            <div className="spinner"></div>
          </div>
        </div>
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
